import React from "react";
import Page, { PageProps } from "../Page";
import { IRoleTypesPresenter } from "../../../presenter/roles/RoleTypesPresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import EditForm, {
  CreateUpdateEditFormProps
} from "../../components/app/editor/form/EditForm";
import RoleTypeDetailsGrid from "./RoleTypeDataGridExpanded";
import TickBox from "../../components/app/grid/TickBox";
import { IDisplayConfiguration } from "../../../model/editform/DisplayConfiguration";
import { IFormItem } from "../../../model/editform/FormItem";
import Loader from "../../components/Loader";

export interface Props extends PageProps {}
export interface State extends IRoleTypesPresenter {}

export default class RoleTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = {
      ...props,
      formItems: [
        {
          type: "input",
          name: "code",
          displayConfiguration: {
            maxLength: 20,
            readOnly: true,
            required: true
          } as IDisplayConfiguration
        },
        {
          type: "input",
          name: "name",
          displayConfiguration: {
            maxLength: 30,
            required: true
          } as IDisplayConfiguration
        },
        {
          type: "textarea",
          name: "description",
          displayConfiguration: {
            minRows: 3,
            required: true
          } as IDisplayConfiguration
        },
        {
          type: "checkbox",
          name: "valid",
          displayConfiguration: {
            checked: false
          } as IDisplayConfiguration
        }
      ] as IFormItem[]
    };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { translate, roleTypes = [] } = this.state;

    const CreateForm = Form.create<CreateUpdateEditFormProps>({})(EditForm);

    CreateForm.defaultProps = {
      formItems: this.state.formItems,
      onSubmit: this.state.createRoleType
    };

    const UpdateForm = Form.create<CreateUpdateEditFormProps>({})(EditForm);

    UpdateForm.defaultProps = {
      formItems: this.state.formItems,
      onSubmit: this.state.updateRoleType,
      rowData: roleTypes
    };

    const columns = [
      {
        title: translate("role_types_page.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("role_types_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("role_types_page.description"),
        dataIndex: "description",
        key: "description"
      },
      {
        title: translate("role_types_page.valid"),
        dataIndex: "valid",
        key: "valid",
        render: (text, record) => <TickBox value={record.valid} />,
        width: "5%"
      }
    ];

    const expandedRowRender = e => {
      return (
        <RoleTypeDetailsGrid
          translate={translate}
          reportingTypes={this.state.reportingTypes}
          assignedReportingTypeCodes={this.state.assignedReportingTypeCodes}
          onReportingTypeSelectChange={this.state.onReportingTypeSelectChange}
          spinnerEnabled={this.state.spinnerEnabled}
          positionTypes={this.state.positionTypes}
          assignedPositionTypeIds={this.state.assignedPositionTypeIds}
          onPositionTypeSelectChange={this.state.onPositionTypeSelectChange}
        />
      );
    };

    const dataGrid = (
      <DataGrid
        title={translate("grids.role-types")}
        translate={translate}
        columns={columns}
        dataSource={roleTypes}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        onCreate={this.state.createRoleType}
        createModalTitle={translate("role_types_page.insert_modal_title")}
        updateForm={UpdateForm}
        updateModalTitle={translate("role_types_page.update_modal_title")}
        onUpdate={this.state.updateRoleType}
        addButtonText={translate("role_types_page.add_button_text")}
        expandedRowRender={expandedRowRender}
        singleRowExpandEnabled={true}
        onExpand={this.state.onRowExpanded}
        booleanColumnKeys={["valid"]}
      />
    );

    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.roleTypesLoader}
        ></Loader>
      </Page>
    );
  }
}
